<app-closeable-dialog-title
  [allowMaximize]="false"
  title="Start new screening process">
</app-closeable-dialog-title>
<div mat-dialog-content>
  <p>
    Select the criteria for excluding papers from the screening process.
    <br>
    You can choose multiple options from the list.
  </p>
  <form [formGroup]="form">

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Exclude Papers for screening which have</mat-label>
      <mat-select formControlName="excludePapers" multiple>
        @for (exclude of excludeList; track $index) {
          <mat-option [value]="exclude.value">{{ exclude.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <section>
      <mat-checkbox formControlName="processFullText">
        Process Full-Text Screening, even if Title/Abstract failed
      </mat-checkbox>
    </section>

    <section>
      <mat-checkbox formControlName="ignoreScreened">
        Exclude papers already screened with LLM
      </mat-checkbox>
    </section>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Advanced Full-Text screening settings</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="advanced-settings">
          <div class="rag-explanation">
            <p>
              <strong>RAG (Retrieval-Augmented Generation) Settings</strong>: These settings control how the AI finds and analyzes relevant sections in papers.
            </p>
          </div>

          <mat-form-field class="full-width">
            <mat-label>Max-Results</mat-label>
            <input matInput type="number" step="1" formControlName="maxResults">
            <mat-hint>
              Maximum number of text segments analyzed per criteria. Higher values increase thoroughness but take longer.
            </mat-hint>
            @if (form.get('maxResults')?.invalid) {
              <mat-error>Value must be between 1 and 10</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Min-Score</mat-label>
            <input matInput type="number" step="0.1" formControlName="minScore">
            <mat-hint>
              Minimum similarity score (0-1) for text to be considered relevant. Higher values mean stricter matching.
            </mat-hint>
            @if (form.get('minScore')?.invalid) {
              <mat-error>Value must be between 0.0 and 1</mat-error>
            }
          </mat-form-field>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
</div>

<div mat-dialog-actions class="actions" align="end">
  <button mat-button class="save-btn" [disabled]="form.invalid" (click)="start()">Start</button>
</div>
